module.exports = __webpack_public_path__ + "static/media/sl.58ef1e3b.svg";